module.exports = __webpack_public_path__ + "media/images/cloud-check-325d8198b4089cab999197f72a530f45.svg";